import React from 'react';

import type { FC } from 'react';

export const ArrowForward: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 18 18" {...props}>
      <path d="M1.34115 7.83229H10.6495L6.58281 11.899C6.25781 12.224 6.25781 12.7573 6.58281 13.0823C6.90781 13.4073 7.43281 13.4073 7.75781 13.0823L13.2495 7.59063C13.5745 7.26562 13.5745 6.74063 13.2495 6.41563L7.76615 0.915625C7.44115 0.590625 6.91615 0.590625 6.59115 0.915625C6.26615 1.24063 6.26615 1.76563 6.59115 2.09063L10.6495 6.16563H1.34115C0.882812 6.16563 0.507812 6.54063 0.507812 6.99896C0.507812 7.45729 0.882812 7.83229 1.34115 7.83229Z" />
    </svg>
  );
};
